import { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import PagesProvider from './Context/PagesProvider';
import ScrollToTop from './Components/Shared/ScrollToTop/ScrollToTop';
import CookieConsent from './Components/Shared/CookieConsent/CookieConsent';

import './App.css';

const LandingPage = lazy(() => import('./Components/LandingPage/LandingPage'));
const AboutPage = lazy(() => import('./Components/AboutPage/AboutPage'));
const ServicesPage = lazy(() => import('./Components/ServicesPage/ServicesPage'));
const ContactPage = lazy(() => import('./Components/ContactPage/ContactPage'));
const Terms = lazy(() => import('./Components/Terms/Terms'));
const Privacy = lazy(() => import('./Components/Privacy/Privacy'));

function App() {
    return (
        <PagesProvider>
            <Router>
                <ScrollToTop />
                <CookieConsent />
                <div className='App'>
                    <Suspense fallback={null}>
                        <Routes>
                            <Route exact path='/' Component={LandingPage} />
                            <Route path='/about' Component={AboutPage} />
                            <Route path='/services' Component={ServicesPage} />
                            <Route path='/contact' Component={ContactPage} />
                            <Route path='/terms-of-service' Component={Terms} />
                            <Route path='/privacy-policy' Component={Privacy} />
                        </Routes>
                    </Suspense>
                </div>
            </Router>
        </PagesProvider>
    );
}

export default App;